function SrId({ title }) {
  return <span className="sr-id">{title}</span>;
}
export default SrId;
